// src/components/Admin/AdminErrorBoundary.jsx
// Aísla errores de un componente hijo para que el resto del dashboard siga
// funcionando, y muestra el error en pantalla en vez de una página en blanco.
// Útil sobre todo para envolver BookingsCalendar mientras depuramos por qué
// no está renderizando nada.
import React from 'react';

class AdminErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error(`[${this.props.label || 'Admin component'}] crashed:`, error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="bg-[#9A0002]/5 border border-[#9A0002]/30 rounded-2xl p-6 text-sm">
          <p className="font-semibold text-[#9A0002]">
            {this.props.label || 'Este componente'} tuvo un error y no se pudo mostrar.
          </p>
          <p className="text-[#3A2A20]/60 mt-1 font-mono text-xs break-all">
            {this.state.error.message}
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

export default AdminErrorBoundary;